/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/ArticleHeader/theme';

export const ArticleHeaderTheme = theme;
